<template>
  <div id="lineShutDown">
    <router-view :countParams="countParams" @getCount="getCount"/>
  </div>
</template>

<script>
import common from '../../script/common'
import amsHome from '../../script/amsHome'

export default {
  data () {
    return {
      countParams: {
        as: {1: 0, 2: 0, 3: 0, 4: 0},
        sq: {1: 0, 2: 0, 3: 0, 4: 0, 5: 0},
        stop: {1: 0, 2: 0, 3: 0},
        cancel: {1: 0, 2: 0, 3: 0}
      }
    }
  },
  mounted () {
    this.$emit('setMenu', 'LineShutDown')
  },
  methods: {
    getCount () {
      amsHome.getHome({}, response => {
        console.log('getHome', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          this.countParams = {
            as: this.getData(data.as, 4),
            sq: this.getData(data.sq, 5),
            stop: this.getData(data.stop, 3),
            cancel: this.getData(data.cancel, 3)
          }
        } else {
          common.amsAlert('retry', '대시보드 통합정보를 불러오지 못했습니다.')
        }
      })
    },
    getData (list, step) {
      let resultMap = {}
      list.forEach(item => {
        resultMap[item.step] = item.cnt
      })
      for (let i = 1; i <= step; i++) {
        if (resultMap[i] == null) {
          resultMap[i] = 0
        }
      }
      return resultMap
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/lineShutDown/LineShutDown.vue